import React from 'react';
import { useInView } from 'react-intersection-observer';

interface Props {
  percent: number;
}

const SimpleDonut: React.FC<Props> = ({ percent }) => {
  const id = Date.now();

  const { ref, inView } = useInView({
    threshold: 1,
  });

  return (
    <svg className="block w-full" viewBox="0 0 100 100" ref={ref}>
      <mask id={`clip-path-${id}`}>
        <rect x="0" y="0" width="100" height="100" fill="white" />
        <circle cx="50" cy="50" r="12" fill="black" />
      </mask>
      <g mask={`url(#clip-path-${id})`}>
        <circle cx="50" cy="50" r="50" fill="white" />
        <circle
          transform="rotate(-90 50 50)"
          className="text-blue-light transition-all duration-500 ease-out delay-200"
          cx="50"
          cy="50"
          r="25"
          fill="none"
          stroke="currentColor"
          strokeWidth="50"
          pathLength="100"
          strokeDasharray={`${inView ? percent : 0} 100`}
        />
      </g>
    </svg>
  );
};

export default SimpleDonut;
